import React from 'react';
import './SkeletonLoader.css'; // Nayi CSS file jo humne banayi

const SkeletonLoader = () => {
    return (
        <div className="container skeleton-container">
            {/* --- Top 3-Column Layout --- */}
            <div className="home-grid-container">
                {/* --- Left Column Skeleton --- */}
                <aside className="left-column">
                    <div className="skeleton-box section-title-skeleton"></div>
                    <div className="skeleton-list-item">
                        <div className="skeleton-box list-media-skeleton"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-box text-skeleton"></div>
                            <div className="skeleton-box text-skeleton short"></div>
                        </div>
                    </div>
                    <div className="skeleton-list-item">
                        <div className="skeleton-box list-media-skeleton"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-box text-skeleton"></div>
                            <div className="skeleton-box text-skeleton short"></div>
                        </div>
                    </div>
                    <div className="skeleton-list-item">
                        <div className="skeleton-box list-media-skeleton"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-box text-skeleton"></div>
                            <div className="skeleton-box text-skeleton short"></div>
                        </div>
                    </div>
                </aside>

                {/* --- Center Column Skeleton --- */}
                <main className="center-column">
                    <div className="skeleton-box kicker-skeleton"></div>
                    <div className="skeleton-box title-skeleton"></div>
                    <div className="skeleton-box text-skeleton"></div>
                    <div className="skeleton-box big-media-skeleton"></div>
                </main>

                {/* --- Right Column Skeleton --- */}
                <aside className="right-column">
                    <div className="skeleton-box section-title-skeleton"></div>
                    <div className="skeleton-list-item">
                        <div className="skeleton-box list-media-skeleton"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-box text-skeleton"></div>
                            <div className="skeleton-box text-skeleton short"></div>
                        </div>
                    </div>
                    <div className="skeleton-list-item">
                        <div className="skeleton-box list-media-skeleton"></div>
                        <div className="skeleton-list-content">
                            <div className="skeleton-box text-skeleton"></div>
                            <div className="skeleton-box text-skeleton short"></div>
                        </div>
                    </div>
                </aside>
            </div>

            {/* --- Lower Section Skeleton --- */}
            <div className="skeleton-box section-title-skeleton"></div>
            <div className="category-grid layout-B">
                <div className="skeleton-card">
                    <div className="skeleton-box card-media-skeleton"></div>
                    <div className="skeleton-card-content">
                        <div className="skeleton-box text-skeleton"></div>
                        <div className="skeleton-box text-skeleton short"></div>
                    </div>
                </div>
                <div className="skeleton-card">
                    <div className="skeleton-box card-media-skeleton"></div>
                    <div className="skeleton-card-content">
                        <div className="skeleton-box text-skeleton"></div>
                        <div className="skeleton-box text-skeleton short"></div>
                    </div>
                </div>
                <div className="skeleton-card">
                    <div className="skeleton-box card-media-skeleton"></div>
                    <div className="skeleton-card-content">
                        <div className="skeleton-box text-skeleton"></div>
                        <div className="skeleton-box text-skeleton short"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonLoader;